import { deepKoamaruLight } from '/b2b/common/colors';

export default theme => ({
    paper: {
        border: '1px solid',
        borderColor: theme.palette.grey[300],
        padding: theme.spacing(3),
        display: 'flex',
        flexDirection: 'column',
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: theme.spacing(2),
    },
    description: {
        color: theme.palette.text.primary,
        marginBottom: theme.spacing(2),
    },
    divider: {
        marginBottom: theme.spacing(3),
    },
    domainSelectWrapper: {
        display: 'flex',
        justifyContent: 'center',
        marginBottom: theme.spacing(2),
    },
    domainSelect: {
        marginBottom: 0,
    },
    icon: {
        marginRight: theme.spacing(1),
    },
    link: {
        fontSize: '0.875rem',
        fontWeight: 500,
    },
    chartCard: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 300,
        padding: theme.spacing(3),
    },
    loadingCard: {
        minHeight: 400,
    },
    noScansCard: {
        textAlign: 'center',
        gap: theme.spacing(2),
    },
    noScansText: {
        color: theme.palette.text.secondary,
    },
    chartContainer: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
    },
    chartTitle: {
        color: theme.palette.text.primary,
        fontWeight: 500,
        marginBottom: theme.spacing(1),
    },
    domainName: {
        color: theme.palette.text.primary,
        fontWeight: 400,
        marginBottom: theme.spacing(2),
    },
    chart: {
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 300,
    },
    chartFooter: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: theme.spacing(2),
        paddingTop: theme.spacing(2),
        borderTop: `1px solid ${theme.palette.divider}`,
    },
    lastScanned: {
        color: deepKoamaruLight,
    },
});
